import { render, staticRenderFns } from "./KodeAkses.vue?vue&type=template&id=2fdda608&scoped=true&"
import script from "./KodeAkses.vue?vue&type=script&lang=js&"
export * from "./KodeAkses.vue?vue&type=script&lang=js&"
import style0 from "./KodeAkses.vue?vue&type=style&index=0&id=2fdda608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdda608",
  null
  
)

export default component.exports